import { supabase } from '../config/supabaseConfig.ts';

export const clientService = {

  // Get all clients
  getAll: async () => {
    try {
      const { data, error } = await supabase
  .from('clientes_usuario')
  .select(`
    id, full_name, email, whatsapp_number, status, last_access_time, auth_user_id,
    proyectos:clientes_projectos (
      id,
      proyecto:project!clientes_projectos_id_proyecto_fkey (
        id, name, description,
        tipo:project_types!project_project_type_fkey (
          id, name, descripcion
        )
      )
    )
  `)
  .order('id', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al obtener clientes:', error);
      throw error;
    }
  },

  toggleClienteStatus: async (id, status) => {
    try {
      const { data, error } = await supabase
        .from('clientes_usuario')
        .update({ status: status })
        .eq('id', id);
      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error al cambiar el estado del cliente:', error);
      throw error;
    }
  },

  deleteClient: async (id) => {
    try {
      const { data, error } = await supabase
        .from('clientes_usuario')
        .delete()
        .eq('id', id)
      if (error) throw error;
      return true;
    } catch (error) {
      console.error('Error al eliminar cliente:', error);
      throw error;
    }
  },

  addClient: async (client) => {
    try {
      const { data, error } = await supabase
        .from('clientes_usuario')
        .insert({
          full_name: client.full_name,
          session_name: client.session_name,
          email: client.email,
          whatsapp_number: client.whatsapp_number,
          auth_user_id: client.auth_user_id,
          status: client.status
        })
        .select();
      if (error) throw error;
      console.log(data[0]);
      return { data: data[0], error: null };
    } catch (error) {
      console.error('Error al crear el cliente:', error);
      return { data: null, error };
    }
  },

  editClient: async (id, client) => {
    try {
      const { data, error } = await supabase
        .from('clientes_usuario')
        .update({
          full_name: client.full_name,
          session_name: client.session_name,
          email: client.email,
          whatsapp_number: client.whatsapp_number,
          status: client.status
        })
        .eq('id', id)
        .select()
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error al editar el cliente:', error);
      return { data: null, error };
    }
  },

  // Vincula un cliente existente con un auth user
  linkAuthUser: async (clientId, authUserId) => {
    try {
      const { data, error } = await supabase
        .from('clientes_usuario')
        .update({ auth_user_id: authUserId })
        .eq('id', clientId)
        .select()
        .single();
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Error al vincular auth user:', error);
      return { data: null, error };
    }
  }

};

export default clientService;
